import React from "react";
import { motion } from "framer-motion";
import {
  FaHeart,
  FaHandsHelping,
  FaStar,
  FaUserShield,
  FaGem,
} from "react-icons/fa";

const values = [
  {
    title: "Compassion",
    icon: <FaHeart />,
  },
  {
    title: "Integrity",
    icon: <FaUserShield />,
  },
  {
    title: "Kindness",
    icon: <FaHandsHelping />,
  },
  {
    title: "Perseverance",
    icon: <FaStar />,
  },
];

const ValueEducation = () => {
  return (
    <section className="bg-[#f8fbff]">

      {/* HERO */}

      <section className="bg-gradient-to-r from-[#07294d] to-[#0b3d68] py-20">

        <div className="max-w-6xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="w-20 h-20 rounded-full bg-white/20 flex items-center justify-center mx-auto mb-6 text-white text-4xl">

              <FaGem />

            </div>

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">

              Cambridge International School

            </p>

            <h1 className="text-5xl md:text-6xl font-black text-white mt-6">

              Value Based Education

            </h1>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          </motion.div>

        </div>

      </section>

      {/* CONTENT */}

      <section className="max-w-6xl mx-auto px-6 py-16">

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-white rounded-[30px] shadow-xl p-10"
        >

          <h2 className="text-4xl font-black text-[#07294d] mb-6">

            Value Based Education

          </h2>

          <div className="w-20 h-1 bg-[#d4af37] rounded-full mb-8"></div>

          <p className="text-gray-600 text-lg leading-9">

            We, at Cambridge believe in creating the individual with a
            harmonious and holistic outlook wherein the value systems
            occupy the top most pedestal. Values are basically general
            principles to regulate our day to day behavior thus
            reflecting the ethos of students at large.

          </p>

          <p className="text-gray-600 text-lg leading-9 mt-6">

            The students are taught by the various values such as love,
            compassion, generosity, honesty, kindness, integrity,
            politeness and perseverance through various power point
            presentations and workshops from time to time.

          </p>

          <p className="text-gray-600 text-lg leading-9 mt-6">

            We believe in making a human being whose essence of life is
            based on values.

          </p>

        </motion.div>

      </section>

      {/* VALUES */}

      <section className="max-w-7xl mx-auto px-6 pb-20">

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">
                    {values.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="bg-white rounded-[28px] shadow-lg border border-gray-100 p-8 text-center"
            >

              <div className="w-20 h-20 mx-auto rounded-2xl bg-[#07294d]/10 text-[#07294d] flex items-center justify-center text-4xl mb-6">

                {item.icon}

              </div>

              <h3 className="text-2xl font-bold text-[#07294d] mb-5">

                {item.title}

              </h3>

              <div className="w-16 h-1 bg-[#d4af37] rounded-full mx-auto"></div>

            </motion.div>

          ))}

        </div>

      </section>

    </section>
  );
};

export default ValueEducation;